import axios, { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { PredefinedSearchFilters } from '@/types';
import { GET_PREDEFINED_SEARCH_FILTERS } from '@/constants';

export const useGetPredefinedSearchFilters = (key?: string | null) => {
  return useQuery<PredefinedSearchFilters, AxiosError>({
    queryKey: ['predefined-search-filters', key],
    queryFn: async () => {
      const res = await axios.get<PredefinedSearchFilters>(GET_PREDEFINED_SEARCH_FILTERS, {
        params: { key },
      });
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 0,
    enabled: Boolean(key),
  });
};
